export function useOverlayScrollHelper() {
  const preventBgFromScrolling = () => {
    document.querySelector('body').style.overflow = 'hidden';
  };
  const allowBgToScroll = () => {
    document.querySelector('body').style.overflow = 'auto';
  };

  return {
    preventBgFromScrolling,
    allowBgToScroll,
  };
}
